import { render, staticRenderFns } from "./PartyCoverVideo.vue?vue&type=template&id=2b8d1f26"
import script from "./PartyCoverVideo.vue?vue&type=script&lang=js"
export * from "./PartyCoverVideo.vue?vue&type=script&lang=js"
import style0 from "./PartyCoverVideo.vue?vue&type=style&index=0&id=2b8d1f26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports